import api from './api';

export interface ImageContainer {
  id: number;
  title: string;
  parent: number | null;
  thumbnail: number | null;
  thumbnail_url: string | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
  children_count: number;
  images_count: number;
}

class ImageContainerService {
  async getAll(params?: any): Promise<ImageContainer[]> {
    const response = await api.get('/image-containers/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<ImageContainer> {
    const response = await api.get(`/image-containers/${id}/`);
    return response.data;
  }

  async create(data: Partial<ImageContainer>): Promise<ImageContainer> {
    const response = await api.post('/image-containers/', data);
    return response.data;
  }

  async update(id: number, data: Partial<ImageContainer>): Promise<ImageContainer> {
    const response = await api.patch(`/image-containers/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/image-containers/${id}/`);
  }

  async getContents(id: number): Promise<{ containers: ImageContainer[]; images: any[] }> {
    const response = await api.get(`/image-containers/${id}/contents/`);
    return response.data;
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/image-containers/reorder/', { items });
  }
}

const imageContainerService = new ImageContainerService();
export default imageContainerService;
